import { memo, ReactElement } from 'react';
import { CurrentThermalComfortContainer, ThermalComfortContainer } from './styles';
import { UnitsInfo } from './components/UnitsInfo';
import { ThermalComfortHistoryCard } from './HistoryCard';
import { UpgradeModule } from '../components/UpgradeModule';
import { ThermalComfortMap } from './Map';
import { useFilterContext } from '../contexts/FilterContext';

interface ThermalComfortProps {
  loading: boolean;
  hasThermalComfort: boolean;
  order: number;
}

function ThermalComfortComponent({
  hasThermalComfort,
  loading,
  order,
}: Readonly<ThermalComfortProps>): ReactElement {
  const { client } = useFilterContext();

  return (
    <ThermalComfortContainer style={{ order }}>
      {!hasThermalComfort && !loading && (<UpgradeModule module="thermalComfort" />)}
      <CurrentThermalComfortContainer>
        <UnitsInfo
          hasThermalComfort={hasThermalComfort}
          loading={loading}
        />
        <ThermalComfortHistoryCard
          hasThermalComfort={hasThermalComfort}
          loading={loading}
        />
      </CurrentThermalComfortContainer>
      <ThermalComfortMap
        key={client ?? 'no-client'}
        loading={loading}
        hasThermalComfort={hasThermalComfort}
      />
    </ThermalComfortContainer>
  );
}

export const ThermalComfort = memo(ThermalComfortComponent, (prev, next) => (
  prev.hasThermalComfort === next.hasThermalComfort
    && prev.loading === next.loading
));
